import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { BranchesContainerProps } from "../../../interfaces/containers";
import Branches from "../../../pages/Profile/Branches";
import { getBranches, cleanBranches } from "../../../actions/profile";

function mapStateToProps(state: BranchesContainerProps) {
    return {
        user: state.auth.user,
        branches: state.profile.branches
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getBranches,
        cleanBranches
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Branches);